import 'vue';
import './helpers.js';
import './config.js';
import { b as registerComponent } from './plugins-627fff4f.js';
import './Icon-4d79248a.js';
import './FormElementMixin-0007468b.js';
import './Input-5c35968d.js';
import './MatchMediaMixin-651dc617.js';
import './trapFocus-e25a0553.js';
import './DropdownItem-e8199af2.js';
import './Select-a60cdba7.js';
import { s as script } from './Timepicker-76bb2c22.js';
export { s as OTimepicker } from './Timepicker-76bb2c22.js';

var index = {
    install(app) {
        registerComponent(app, script);
    }
};

export default index;
